<script>
export default{
  name: "FooterBar",
}
</script>

<template>
  <div class="fixed rounded-md bottom-0 left-0 right-0 bg-white p-4 shadow-md flex justify-between my-4 mx-auto max-w-2xl">
    <button class="text-slate-600 px-4 py-2">Discard</button>
    <button class="bg-woot-600 text-white px-4 py-2 rounded" @click="$emit('next')">Next</button>
  </div>
</template>